export default __webpack_public_path__ + "static/BASF-b4cea245b0117a2bfdf467e4579b73ac.svg";